import Link from "next/link";
import ResourcesModal from "@/components/resources_modal";
import Image from "next/image";
import { getProductLink } from "@/lib/utils.js";
import { CartContext } from "@/lib/cart_context.js";
import { useState, useContext } from "react";
import SavedConfigurations from "@/components/saved_configurations.js";
import ShareSvg from "@/components/svgs/share_svg.js";
import DownloadSvg from "@/components/svgs/download_svg.js";
import DeleteSvg from "@/components/svgs/delete_svg.js";
import ResourceList from "@/components/resource_list";
import BulkAssetLinks from "@/components/bulk_asset_links";

export default function SavedItemRow({
  product,
  removeItem,
  canEdit,
  resource_display,
  config,
}) {
  const cart = useContext(CartContext);
  const [configurationsOpen, setConfigurationsOpen] = useState(false);
  const [show, setShow] = useState(false);
  const [showDownload, setShowDownload] = useState(false);
  const [showShare, setShowShare] = useState(false);
  const productLink = getProductLink(product);
  const threshold =  3

  const downloadsForKeyCount = (key) => {
    return (product.downloads || {})[key]?.length;
  };

  return (
    <div className="lexcms-saved-items-table-row-container">
      <div className="lexcms-saved-items-table-row">
        <div className="lexcms-saved-items-table-value-box">
          <div className="lexcms-saved-items-table-values lexcms-product-info-cell">
            <div className="lexcms-saved-items-table-product-image-container">
              <a href={productLink}>
                <Image
                  priority
                  src={product.image}
                  layout={"fill"}
                  alt={""}
                  className="lexcms-product-saved-items-image"
                />
              </a>
            </div>
            <div className="lexcms-saved-items-product-info-container">
              <a href={productLink}>
                <h4>{product.name}</h4>
              </a>
              <h5>{product.sub_name} </h5>
              <div className="lexcms-saved-item-action-row">
                {canEdit && (
                  <a onClick={() => removeItem(product.id)}>
                    <DeleteSvg />
                    Delete
                  </a>
                )}
                {product.part_numbers?.length > 0 && (
                  <a onClick={() => setConfigurationsOpen((open) => !open)}>
                    Show Configurations ({product.part_numbers?.length})
                    <span
                      className={`lexcms-accordion-arrow${
                        configurationsOpen ? " --open" : ""
                      }`}
                    >
                      &nbsp;
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="lexcms-saved-items-table-value-box">
          <p className="lexcms-saved-items-table-values ">
            {product.description}
          </p>
        </div>
        <div className="lexcms-saved-items-table-value-box">
          <div class="lexcms-saved-items-resource-lists">
            {Object.keys(product.downloads || {}).map((key, i) => {
              return (
                <div className="lexcms-saved-items-table-values ">
                  <p className="lexcms-saved-items-asset-type">{key}</p>

                  {product.downloads[key]?.slice(0, resource_display === 'modal' ? threshold : product.downloads[key].length)?.map((d, i) => {
                    return (
                      <p key={i}>
                        <a href={d.url} target="_blank">
                          {d.name}
                        </a>
                      </p>
                    );
                  })}
                  {resource_display === "modal" &&
                    downloadsForKeyCount(key) > threshold && (
                      <div
                        className="lexcms-product-download-view-all-section"
                        onClick={() => setShow(key)}
                      >
                        <div className="lexcms-product-download-view-all">
                          View All
                        </div>
                        <div className="lexcms-product-download-view-all-count">
                          ({downloadsForKeyCount(key)})
                        </div>
                        <div className="lexcms-product-download-view-all-icon"></div>
                      </div>
                    )}
                </div>
              );
            })}
          </div>
          <BulkAssetLinks product={product} config={config} />
        </div>
      </div>
      {resource_display === "modal" && show && (
        <ResourcesModal show={show} setShow={setShow}>
          <h3>
            <strong>{product.name} </strong>: {show}
          </h3>
          <hr className="lexcms-section-divider"></hr>
          <ul className="lexcms-product-download-list">
            {product.downloads[show]?.map((download, i) => {
              return (
                <li className="lexcms-product-download-filename">
                  <a href={download.url} target="_blank">
                    {download.name}
                  </a>
                </li>
              );
            })}
          </ul>
        </ResourcesModal>
      )}

      {configurationsOpen && (
        <SavedConfigurations
          product={product}
          canEdit={canEdit}
          open={configurationsOpen}
          setOpen={setConfigurationsOpen}
          cart={cart}
          productLink={productLink}
        />
      )}
    </div>
  );
}
